import produce from 'immer';
import {
  types,
  EventActionTypes,
  EventPayload,
  EventState,
  GetEventsPending,
  LogEventPending,
  GetEventsSuccess,
  GetLatestEventsSuccess,
  GetEventsError,
  LogEventError
} from './types';

// Actions
export const actions = {
  logEvent: (payload: EventPayload): EventActionTypes => ({
    type: types.LOG_EVENT_ASYNC.REQUEST,
    payload
  }),
  getEvents: (): EventActionTypes => ({ type: types.GET_EVENTS_ASYNC.REQUEST }),
  getLatestEvents: (): EventActionTypes => ({ type: types.GET_LATEST_EVENTS_ASYNC.REQUEST })
};

// Initial State
export const initialState: EventState = {
  latest: {
    kioskEvents: [],
    kioskHardwareEvents: []
  },
  history: {
    kioskEvents: [],
    kioskHardwareEvents: []
  },
  loading: false,
  error: undefined
};

// Reducer
export const reducer = (state: EventState = initialState, action: EventActionTypes): EventState => {
  return produce(state, draft => {
    switch (action.type) {
      case types.GET_EVENTS_ASYNC.SUCCESS:
        draft.history = (action as GetEventsSuccess).payload;
        break;
      case types.GET_LATEST_EVENTS_ASYNC.SUCCESS:
        draft.latest = (action as GetLatestEventsSuccess).payload;
        break;
      case types.LOG_EVENT_ASYNC.PENDING:
      case types.GET_EVENTS_ASYNC.PENDING:
      case types.GET_LATEST_EVENTS_ASYNC.PENDING:
        draft.loading = (action as GetEventsPending | LogEventPending).payload;
        break;
      case types.GET_EVENTS_ASYNC.ERROR:
      case types.LOG_EVENT_ASYNC.ERROR:
      case types.GET_LATEST_EVENTS_ASYNC.ERROR:
        draft.error = (action as GetEventsError | LogEventError).payload;
        break;
      default:
      // Do nothing
    }
    return draft;
  });
};
